if (!customElements.get('lookbook-pinpoint')) {
class LookbookPinpoint extends HTMLElement {
  constructor() {
    super();
    this.handleMouseEnter = this.handleMouseEnter.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
    this.handleFocusIn = this.handleFocusIn.bind(this);
    this.handleFocusOut = this.handleFocusOut.bind(this);
  }

  connectedCallback() {
    this.addEventListeners();
  }

  disconnectedCallback() {
    this.removeEventListeners();
  }

  addEventListeners() {
    this.addEventListener('mouseenter', this.handleMouseEnter);
    this.addEventListener('mouseleave', this.handleMouseLeave);
    this.addEventListener('focusin', this.handleFocusIn);
    this.addEventListener('focusout', this.handleFocusOut);
  }

  removeEventListeners() {
    this.removeEventListener('mouseenter', this.handleMouseEnter);
    this.removeEventListener('mouseleave', this.handleMouseLeave);
    this.removeEventListener('focusin', this.handleFocusIn);
    this.removeEventListener('focusout', this.handleFocusOut);
  }

  handleMouseEnter() {
    this.classList.add('block__pinpoint--active');
    this.closest(".lookbook__block--image").classList.add('lookbook__block--image--active');
  }

  handleMouseLeave(event) {
    if (!this.contains(event.relatedTarget)) {
      this.classList.remove('block__pinpoint--active');
      this.closest(".lookbook__block--image").classList.remove('lookbook__block--image--active');
    }
  }

  handleFocusIn() {
    this.classList.add('block__pinpoint--active');
    this.closest(".lookbook__block--image").classList.add('lookbook__block--image--active');
  }

  handleFocusOut(event) {
    if (!this.contains(event.relatedTarget)) {
      this.classList.remove('block__pinpoint--active');
      this.closest(".lookbook__block--image").classList.remove('lookbook__block--image--active');
    }
  }
}


  customElements.define('lookbook-pinpoint', LookbookPinpoint);
}
